const STORAGE_KEY = 'credit-events';

export interface CreditEventSeenEntry {
  isSeen: boolean;
}

type CreditEventsStored = Record<string, CreditEventSeenEntry>;

function readStored(): CreditEventsStored {
  if (typeof window === 'undefined') {
    return {};
  }
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return {};
    }
    const parsed: unknown = JSON.parse(raw);
    if (
      parsed !== null &&
      typeof parsed === 'object' &&
      !Array.isArray(parsed)
    ) {
      return parsed as CreditEventsStored;
    }
  } catch (err) {
    console.error('Error reading credit events from localStorage:', err);
  }
  return {};
}

export function shouldAutoOpenCreditEventForNotification(
  notificationId: string,
): boolean {
  return readStored()[notificationId]?.isSeen !== true;
}

export function markCreditEventNotificationSeen(notificationId: string): void {
  if (typeof window === 'undefined') {
    return;
  }
  const next = {
    ...readStored(),
    [notificationId]: { isSeen: true },
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
}
